export default __webpack_public_path__ + "static/pillar-2-952f912cf5dfe8befe33a7c4dd782d10.jpg";